export const YELLOW_THRESHOLD_FIELD = 'yellowThreshold';
export const RED_THRESHOLD_FIELD = 'redThreshold';

const MIN_YELLOW_HOURS = 1;
const MAX_YELLOW_HOURS = 88;
const MIN_RED_HOURS = 2;
const MAX_RED_HOURS = 96;

export const parseHours = (threshold) => parseInt(threshold, 10);

export const formatThreshold = (hours) =>
  `${hours.toString().padStart(2, '0')}:00:00`;

const formatHoursOption = (hours) => ({
  label: `${hours} ${hours === 1 ? 'Hour' : 'Hours'}`,
  value: formatThreshold(hours),
});

const buildHoursOptions = (minHours, maxHours, disabledThreshold = 0) =>
  Array.from({ length: maxHours - minHours + 1 }, (_, index) => {
    const hours = minHours + index;
    const isDisabled = hours <= disabledThreshold;
    return { ...formatHoursOption(hours), disabled: isDisabled };
  });

const DEFAULT_THRESHOLD_OPTION = { label: 'default', value: '' };

export const YELLOW_THRESHOLD_OPTIONS = [
  DEFAULT_THRESHOLD_OPTION,
  ...buildHoursOptions(MIN_YELLOW_HOURS, MAX_YELLOW_HOURS),
];

export const getRedThresholdOptions = (yellowThreshold) => [
  DEFAULT_THRESHOLD_OPTION,
  ...buildHoursOptions(
    MIN_RED_HOURS,
    MAX_RED_HOURS,
    parseHours(yellowThreshold),
  ),
];

export const applyThresholdChange = (preference, field, value) => {
  const isDefaultOptionSelected = !value;

  if (isDefaultOptionSelected) {
    return {
      ...preference,
      [YELLOW_THRESHOLD_FIELD]: null,
      [RED_THRESHOLD_FIELD]: null,
    };
  }

  const updatedPreference = { ...preference, [field]: value };

  if (field === YELLOW_THRESHOLD_FIELD) {
    const redInvalidOrDefault =
      !updatedPreference[RED_THRESHOLD_FIELD] ||
      parseHours(updatedPreference[RED_THRESHOLD_FIELD]) <= parseHours(value);

    if (redInvalidOrDefault) {
      updatedPreference[RED_THRESHOLD_FIELD] = formatThreshold(
        parseHours(value) + 1,
      );
    }
  }

  if (
    field === RED_THRESHOLD_FIELD &&
    !updatedPreference[YELLOW_THRESHOLD_FIELD]
  ) {
    updatedPreference[YELLOW_THRESHOLD_FIELD] = formatThreshold(
      Math.min(parseHours(value) - 1, MAX_YELLOW_HOURS),
    );
  }

  return updatedPreference;
};
